import React, { useContext, useEffect, useState } from 'react'

import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { Nullable } from '@application/Types/Opt'
import { AcceptCookiesModal } from '@icontainers/design-system/dist/molecules/AcceptCookiesModal'
import { Context } from '@infrastructure/Context'
import { isMandatoryCookieAccepted } from '@infrastructure/Cookies'
import { useLocation } from '@reach/router'
import { useVirtualPageViewGa4Event } from '@src/Infrastructure/GoogleTagManager/GA4Events'

import { getCookieInfo, onAccept } from './utils'

export const CookieMessage = (): Nullable<JSX.Element> => {
    const { t } = useTranslation()
    const location = useLocation()
    const { setSendMixpanelEvents } = useContext(Context)

    const [accepted, setAccepted] = useState(true)

    const sendVirtualPageViewGa4Event = useVirtualPageViewGa4Event(location)

    useEffect(() => {
        if (!isMandatoryCookieAccepted()) {
            setAccepted(false)
        }
    }, [])

    return (
        <AcceptCookiesModal
            isOpen={!accepted}
            title={t('cookieTitle')}
            description={t('cookieDescription')}
            cookiePolicyLabel={t('viewCookiePolicyLabel')}
            cookiePolicyUrl={t('cookiePolicyURL')}
            acceptAllBtnText={t('acceptAllCookies')}
            managePreferencesBtnText={t('managePreferencesBtnText')}
            managePreferencesTitle={t('managePreferencesTitle')}
            managePreferencesDescription={t('managePreferencesDescription')}
            confirmMyChoicesBtnText={t('confirmMyChoicesBtnText')}
            alwaysActiveText={t('alwaysActiveText')}
            cookiesInfo={getCookieInfo(t)}
            onAccept={onAccept({
                setAccepted,
                location,
                sendVirtualPageViewGa4Event,
                setSendMixpanelEvents,
            })}
        />
    )
}
